import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withDebugTracing,
} from '@angular/router';
import { routes } from '@app/src/app/routes/app.routes';
import {
  provideClientHydration,
  withEventReplay,
} from '@angular/platform-browser';
import { environment } from '@app/src/environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ActivityLogModelsProvider,
  ApiTokenProvider,
  ApiUrlProvider,
  DashboardProviders,
  ErrorInterceptorHandlerProvider,
  GraphqlProvider,
  HttpClientInterceptors,
  IconsListProvider,
  MetaStrategyProvider,
  ModalDecoratorContextProvider,
  SecretValuesInitializerProvider,
  TranslationInitializationProvider,
} from '@ckmk/angular';
import { DashboardViewService } from '@app/src/app/modules/admin/services/view/dashboard.view.service';
import { faAnglesRight } from '@fortawesome/free-solid-svg-icons/faAnglesRight';
import { faChartLine } from '@fortawesome/free-solid-svg-icons/faChartLine';
import { faPersonChalkboard } from '@fortawesome/free-solid-svg-icons/faPersonChalkboard';
import { PostCategoryModel } from '@app/src/app/modules/post/classes/category/model/post.category.model';
import { SolutionModel } from '@app/src/app/modules/solution/classes/default/model/solution.model';
import { ServiceModel } from '@app/src/app/modules/service/classes/default/model/service.model';
import { SolutionCategoryModel } from '@app/src/app/modules/solution/classes/category/model/solution.category.model';
import { ServiceCategoryModel } from '@app/src/app/modules/service/classes/category/model/service.category.model';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import { faBrain } from '@fortawesome/free-solid-svg-icons/faBrain';
import { faHexagonNodes } from '@fortawesome/free-solid-svg-icons/faHexagonNodes';
import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner';
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      ...(!environment.production ? [] : [withDebugTracing()]),
    ),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors(HttpClientInterceptors(true))),
    GraphqlProvider(),
    DashboardProviders({
      viewService: DashboardViewService,
    }),
    IconsListProvider({
      seeMore: faAnglesRight,
      chartLine: faChartLine,
      chalkBoard: faPersonChalkboard,
      brain: faBrain,
      achievement: faHexagonNodes,
      optimisation: faSpinner,
      clock: faClock,
      save: faFloppyDisk,
    }),
    ApiTokenProvider(environment.API_TOKEN),
    ActivityLogModelsProvider({
      posts: PostModel,
      posts_categories: PostCategoryModel,
      solutions: SolutionModel,
      solutions_categories: SolutionCategoryModel,
      services: ServiceModel,
      services_categories: ServiceCategoryModel,
    }),
    ApiUrlProvider(environment.API_URL),
    MetaStrategyProvider({
      siteName: environment.SITE_NAME,
      baseUrl: environment.FRONT_URL,
      defaultImagePath: '/img/front-header.jpg',
    }),
    SecretValuesInitializerProvider(),
    TranslationInitializationProvider(),
    ModalDecoratorContextProvider(),
    // ErrorInterceptorHandlerProvider(),
  ],
};
